import React, { useEffect, useState } from "react";
import { Checkbox, Flex, Text, TextField } from "@radix-ui/themes";
import { useGetBloomreachConsentCategories } from "hooks";

function toggleId(current, id, checked) {
  const next = new Set(current || []);
  if (checked) next.add(id);
  else next.delete(id);
  return Array.from(next);
}

export function parseConsentCategoryText(value) {
  return String(value || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .filter((part, index, all) => all.indexOf(part) === index);
}

export function BloomreachConsentSection({
  organisationId,
  categories: selected,
  onChange,
  disabled = false,
  enabled = true,
}) {
  const { data, isFetched } = useGetBloomreachConsentCategories(organisationId, enabled);
  const categories = data?.data?.categories || [];
  const loadFailed = data?.data?.status === "error";
  const useTextEntry = loadFailed || (isFetched && !categories.length);
  const [draft, setDraft] = useState((selected || []).join(", "));

  useEffect(() => {
    const incoming = (selected || []).join(", ");
    if (parseConsentCategoryText(draft).join(", ") !== incoming) {
      setDraft(incoming);
    }
  }, [selected, draft]);

  return (
    <Flex direction="column" gap="2" style={{ width: "100%" }}>
      <Text size="2" weight="medium">
        Tick these categories when a guest opts in
      </Text>
      <Text size="1" color="gray">
        BConnect collects one marketing opt-in. Each selected category is sent as its own consent event. Leave this empty to skip consent.
      </Text>
      {useTextEntry ? (
        <TextField.Root
          size="2"
          value={draft}
          disabled={disabled}
          placeholder="newsletter, cah"
          onChange={(event) => {
            setDraft(event.target.value);
            onChange(parseConsentCategoryText(event.target.value));
          }}
        />
      ) : (
        <Flex wrap="wrap" gap="3">
          {categories.map((category) => (
            <Flex key={category.id} align="center" gap="2" asChild>
              <label style={{ cursor: disabled ? "default" : "pointer" }}>
                <Checkbox
                  checked={(selected || []).includes(category.id)}
                  disabled={disabled}
                  onCheckedChange={(checked) =>
                    onChange(toggleId(selected, category.id, checked === true))
                  }
                />
                <Text size="2">{category.name || category.id}</Text>
              </label>
            </Flex>
          ))}
        </Flex>
      )}
      {loadFailed ? (
        <Text size="1" color="gray">
          Bloomreach did not return its consent categories. Type the category ids, separated by commas.
        </Text>
      ) : null}
    </Flex>
  );
}
